var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"login-page"},[_c('h4',[_vm._v("Login")]),_c('a',{attrs:{"href":"/auth/spotify"}},[_vm._v("Login using your Spotify account")])])
}]

export { render, staticRenderFns }